import { css } from '@emotion/core'
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme'

const { sysColorBackgroundSurface } = PAYPAL_THEME

export const loadingSkeletonCss = css`
  padding: 20px;
`

export const skeletonTitleCss = css`
  height: 24px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 16px;
  animation: pulse 1.5s infinite;
`

export const skeletonContentCss = css`
  height: 200px;
  background-color: #f0f0f0;
  border-radius: 4px;
  margin-bottom: 20px;
  animation: pulse 1.5s infinite;
`

export const skeletonButtonContainerCss = css`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`

export const skeletonButtonSmallCss = css`
  height: 40px;
  width: 100px;
  background-color: #f0f0f0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
`

export const skeletonButtonLargeCss = css`
  height: 40px;
  width: 140px;
  background-color: #f0f0f0;
  border-radius: 4px;
  animation: pulse 1.5s infinite;
`

export const contentSectionCss = css`
  margin-bottom: 2rem;
  text-align: center;
`

export const headerTextCss = css`
  font-family: 'PayPalPro-Black';
  margin-top: 2rem;
  font-size: 40px;
  line-height: 40px;
  letter-spacing: -1px;
`

export const subHeaderTextCss = css`
  font-family: 'PayPalPlain-Regular';
  font-size: 16px;
  line-height: 16px;
`

export const contentImageCss = css`
  width: 100%;
  max-width: 300px;
  margin-top: 4rem;
  margin-bottom: 4rem;
`

export const fixedBottomContainerCss = css`
  left: 0;
  bottom: 0;
  position: fixed;
  width: 100%;
  text-align: center;
  box-shadow: 0px 0px 8px 0px #00000014;
  background-color: ${sysColorBackgroundSurface};
  z-index: 1000;
`

export const checkboxContainerCss = css`
  text-align: center;
  font-family: 'PaypalPlain-Regular';
  margin-top: 2.5rem;
`

export const checkboxInputCss = css`
  margin-top: 0px;
`

export const checkboxLabelCss = css`
  margin-left: 0.5rem;
  display: inline-block;
  text-align: left;
`

export const checkboxSubTextCss = css`
  color: gray;
  font-family: 'PaypalPlain-Regular';
  font-size: 12px;
`

export const ctaButtonCss = css`
  margin: 2.5rem auto 2.5rem;
  background-color: black;
  border-color: black;
  width: 344px;
  height: 48px;
  font-family: 'PayPalPlain-Regular';
`

export const psHeaderTextCss = css`
  text-align: left !important;
`

export const psBodyTextCss = css`
  text-align: left;
  margin-bottom: 12px;

  span::before {
    content: '✓';
    color: #0070ba;
    font-weight: 700;
    margin-right: 8px;
  }
`


export const psContainerCss = css`
  [data-testid^='ps-block-'] {
    display: grid;
    grid-template-columns: 1fr auto;
    column-gap: 16px;
    align-items: start;
    width: 100%;
    margin-top: 24px;
  }


  [data-testid^='ps-block-'] [data-testid='ps-text-body']:last-of-type {
    border-bottom: 1px solid #c7ccd1 !important;
    padding-bottom: 24px !important;
    margin-bottom: 32px !important;
  }


  [data-testid^='ps-block-'] [data-testid='ps-text-body'] + [data-testid='ps-text-caption'] {
    border-top: 1px solid #c7ccd1 !important;
    padding-top: 24px !important;
    margin-top: 32px !important;
  }


  [data-testid^='ps-block-'] > [data-testid='ps-text-heading'] {
    grid-column: 1;
    text-align: left;
  }


  [data-testid^='ps-block-'] > [role='img'] {
    grid-column: 2;
    justify-self: end;
    margin: 0;
    width: 150px;
    height: 100px;
  }

  
  [data-testid^='ps-block-'] > [data-testid='ps-text-body'],
  [data-testid^='ps-block-'] > [data-testid='ps-text-caption'],
  [data-testid^='ps-block-'] > [class*='ppvx_button'] {
    grid-column: 1 / -1;
  }


  
  [data-testid^='ps-block-'] > [data-testid='ps-text-caption']:last-of-type {
    border-top: 1px solid #c7ccd1;
    padding: 12px 0;
    margin: 16px 0 8px;
    color: #6c7378;
    font-size: 12px;
    line-height: 1.4;
  }

  
  [data-testid^='ps-block-'] > [data-testid='ps-text-caption'] {
    color: #6c7378;
    font-size: 12px;
    line-height: 1.4;
  }


  [data-testid^='ps-primary-button-'] {
    grid-column: 1 / -1;
    width: 100%;
    max-width: 344px;
    height: 48px;
    border-radius: 999px;
    margin: 16px auto 24px;
  }
`


export const psCenterContainerCss = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  [data-testid*='ps-'] {
    width: 100%;
  }
  
  img {
    max-width: 300px;
    margin: 0 auto 20px;
  }
`


export const psSideLayoutCss = css`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 40px;
  align-items: start;
  

  [data-testid*='ps-image'] {
    grid-column: 1;
  }
  

  [data-testid*='ps-info'],
  [data-testid*='ps-button'] {
    grid-column: 2;
  }
`

export const modalOverrideCss = css`
  .ppvx_modal-header__close {
    display: none;
  }
  
  scrollbar-width: none;
  
  &::-webkit-scrollbar {
    display: none;
  }
  
  @media (max-width: 47rem) {
    .ppvx_modal-header {
      height: 52px;
      min-height: 52px;
      padding: 8px 0;
    }
  }
`
export const noOffersCss = css`
  .error-tag {
    margin-top: 5.75rem;
    margin-bottom: 2rem;
    width: 10rem;
  }
  .subtitle {
    margin-top: 0.25rem;
    color: grey;
  }

  #pay-another-way {
    margin-top: 10rem;
    width: 100%;
  }

  text-align: center;
  margin-top: 10em;
`